import effectManager from '../../module/effect';
import mousePararax from "../../module/mouse/pararax";

let eff = new effectManager();

export default class kvManager {
    constructor(ua) {

        this.w;
        this.wHalf;

        this.ua = ua;

        /* DOM */
        // this.$target = $(".js__mouse-para")

        this.$headerCnt = this.ua === "pc" ? $("#l-header-title .l-logo,#l-header-navi-list li") : $("#l-header-title .l-logo,#l-header-navi-trigger");

        /* module */


        /* STATUS */
        this.status = {
            kvbg : true, /* 表示しているか */
            comp : false, /* スプラッシュが完了しているか */
            obj :[]
        }

        if(Useragnt.pc) this.kvPara = new mousePararax($("#p-kv"));

        eff.splitTextKV($(".js__splash-splittext"),"set");
        eff.blur($(".js__splash-show"),"set");
        eff.blur($(".js__splash-show-bg"),"set");
        eff.show(this.$headerCnt,"set")
        eff.opacity($("#p-kv-info,#l-scrolldown,#l-sns li"),"set")

    }
    init(){

        let _this = this;

        eff.blur($(".js__splash-show-bg"),"show");

        eff.splitTextKV($(".js__splash-splittext >* >*"),"show");
        //
        setTimeout(function () {
            eff.blur($(".js__splash-show"),"show");
            TweenMax.to(
                $(".js__splash-splittext.p-line2 >*:nth-child(1)").find(">*:nth-child(5),>*:nth-child(6),>*:nth-child(7),>*:nth-child(8),>*:nth-child(9)"),
                0.8,{
                    color : "#fff"
                }
            )
            TweenMax.to(
                $(".js__splash-splittext.p-line2 >*:nth-child(2)").find(">*:nth-child(1),>*:nth-child(2)"),
                0.8,{
                    color : "#fff",
                    onComplete:function () {
                        eff.show(_this.$headerCnt,"show")
                        if(Useragnt.tablet) eff.show($("#l-header-navi-list li"),"show")
                        eff.opacity($("#p-kv-info,#l-scrolldown,#l-sns li"),"show")
                        _this.status.comp = true;
                    }
                }
            )
        },3e3);

    }
    render(mouse){

        if(Useragnt.pc) this.kvPara.render(mouse);

    }
    resize(w) {

        this.w = w;
        // this.wHalf = this.w / 2;
        if(Useragnt.pc) this.kvPara.resize(w);

    }
    show(){ /* bodyエリアで表示させる場合に使う */
        this.status.kvbg = true;
        TweenMax.killChildTweensOf($("#p-kv-content-img__inner,#p-kv-bg"));
        eff.bodyKv($("#p-kv-content-img__inner .js__splash-show"),"show");
        eff.bodyKv($("#p-kv-bg .js__splash-show-bg"),"show");
    }
    out(){ /* bodyエリアで消す場合に使う */
        this.status.kvbg = false;
        TweenMax.killChildTweensOf($("#p-kv-content-img__inner,#p-kv-bg"));
        eff.bodyKv($("#p-kv-content-img__inner .js__splash-show"),"out");
        eff.bodyKv($("#p-kv-bg .js__splash-show-bg"),"out");
    }

}